import React from "react";
import Lottie from "react-lottie";
import "./No_data_lottie.css";
import animationData from "./No_data_lottie.json";

const No_data_lottie = () => {

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="main">
      <div className="No_data_lottie_icon">
        <Lottie
          options={defaultOptions}
        />
      </div>
    </section>
  );
};

export default No_data_lottie;